import React from 'react';
import {
  Scissors,
  Stethoscope,
  ShoppingBag,
  Briefcase,
  UtensilsCrossed,
  Building2,
} from 'lucide-react';
import { customerCategories } from '../data/testimonials';

const ICONS = {
  Scissors,
  Stethoscope,
  ShoppingBag,
  Briefcase,
  UtensilsCrossed,
  Building2,
};

export default function CustomerLogos() {
  return (
    <section
      aria-label="Industries we serve"
      className="py-10 sm:py-14 px-4 sm:px-6 lg:px-8"
    >
      <div className="max-w-5xl mx-auto text-center">
        <p
          className="text-xs sm:text-sm font-medium uppercase tracking-wider mb-6"
          style={{ color: 'var(--text-muted)' }}
        >
          Built for businesses across Africa
        </p>
        <ul className="flex flex-wrap items-center justify-center gap-3 sm:gap-4">
          {customerCategories.map(({ label, icon }) => {
            const Icon = ICONS[icon] || Briefcase;
            return (
              <li
                key={label}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium"
                style={{
                  background: 'var(--bg-card)',
                  border: '1px solid var(--border-card)',
                  color: 'var(--text-body)',
                  boxShadow: 'var(--shadow-card)',
                }}
              >
                <Icon className="w-4 h-4" style={{ color: 'var(--text-accent)' }} />
                {label}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
